import React from 'react';

//styles
import { Loader, LoaderParts, LoaderWrapper } from './ButtonLoader.styled';

export const ButtonLoader = () => (
  <LoaderWrapper>
    <Loader>
      <LoaderParts />
      <LoaderParts />
      <LoaderParts />
    </Loader>
  </LoaderWrapper>
);
